(function () {
  'use strict';

  var doc = document;
  var strings = (window.theme && window.theme.strings) || {};
  var routes = (window.theme && window.theme.routes) || { cart: '/cart', cartAdd: '/cart/add.js', cartJs: '/cart.js' };

  function qs(selector, ctx) { return (ctx || doc).querySelector(selector); }
  function qsa(selector, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(selector)); }

  /* ---------- Mobile navigation ---------- */
  var navToggle = qs('[data-nav-toggle]');
  var mobileNav = qs('#MobileNav');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () {
      var open = navToggle.getAttribute('aria-expanded') === 'true';
      navToggle.setAttribute('aria-expanded', String(!open));
      mobileNav.hidden = open;
    });
    doc.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !mobileNav.hidden) {
        navToggle.click();
        navToggle.focus();
      }
    });
  }

  /* ---------- Toast ---------- */
  var toast = qs('[data-toast]');
  var toastTimer;
  function showToast(message, isError, withCartLink) {
    if (!toast) return;
    toast.textContent = message;
    if (withCartLink) {
      var link = doc.createElement('a');
      link.href = routes.cart;
      link.textContent = strings.viewCart || 'View cart';
      toast.appendChild(link);
    }
    toast.classList.toggle('toast--error', !!isError);
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 4000);
  }

  /* ---------- Cart count ---------- */
  function refreshCartCount() {
    fetch(routes.cartJs, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        qsa('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  /* ---------- Ajax add to cart (progressive enhancement: forms still work without JS) ---------- */
  doc.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-ajax-cart')) return;
    event.preventDefault();

    var button = qs('[type="submit"]', form);
    if (button) { button.disabled = true; button.classList.add('is-loading'); }

    fetch(routes.cartAdd, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json().then(function (body) { return { ok: response.ok, body: body }; });
      })
      .then(function (result) {
        if (!result.ok) throw new Error(result.body.description || result.body.message || strings.error);
        refreshCartCount();
        showToast(strings.added || 'Added to cart.', false, true);
      })
      .catch(function (err) {
        showToast(err.message || strings.error || 'Could not add to cart.', true);
      })
      .then(function () {
        if (button) { button.disabled = false; button.classList.remove('is-loading'); }
      });
  });

  /* ---------- Product page: variants, price, gallery ---------- */
  function initProduct(section) {
    var dataEl = qs('[data-variants]', section);
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var form = qs('form.product-form', section);
    var idInput = form ? qs('input[name="id"]', form) : null;
    var button = qs('[data-add-btn]', section);
    var priceEl = qs('[data-price]', section);
    var soldOutNote = qs('[data-soldout-note]', section);
    var groups = qsa('.variant-group', section);
    var currency = section.getAttribute('data-currency') || 'USD';
    var formatter;
    try {
      formatter = new Intl.NumberFormat(doc.documentElement.lang || undefined, { style: 'currency', currency: currency });
    } catch (e) {
      formatter = { format: function (n) { return n.toFixed(2); } };
    }

    function money(cents) { return formatter.format(cents / 100); }

    function priceHtml(v) {
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      var html = '<span class="price' + (onSale ? ' price--sale' : '') + '"><span class="price__now">' + money(v.price) + '</span>';
      if (onSale) html += '<s class="price__was">' + money(v.compare_at_price) + '</s>';
      return html + '</span>';
    }

    function selectedOptions() {
      return groups.map(function (group) {
        var radio = qs('input:checked', group);
        if (radio) return radio.value;
        var select = qs('select', group);
        return select ? select.value : null;
      });
    }

    function findVariant(options) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < options.length; j++) {
          if (v.options[j] !== options[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function showMedia(id) {
      var slides = qsa('[data-slide]', section);
      var target = slides.filter(function (s) { return String(s.getAttribute('data-media-id')) === String(id); })[0];
      if (!target) return;
      slides.forEach(function (s) { s.hidden = s !== target; });
      qsa('[data-thumb]', section).forEach(function (t) {
        t.classList.toggle('is-active', String(t.getAttribute('data-thumb')) === String(id));
      });
    }

    qsa('[data-thumb]', section).forEach(function (thumb) {
      thumb.addEventListener('click', function () { showMedia(thumb.getAttribute('data-thumb')); });
    });

    function update() {
      if (!groups.length || !button) return;
      var variant = findVariant(selectedOptions());
      if (!variant) {
        button.disabled = true;
        button.textContent = strings.unavailable || 'Unavailable';
        return;
      }
      if (idInput) {
        idInput.value = variant.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      button.disabled = !variant.available;
      button.textContent = variant.available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out');
      if (soldOutNote) soldOutNote.hidden = !!variant.available;
      if (priceEl) priceEl.innerHTML = priceHtml(variant);
      if (variant.featured_media && variant.featured_media.id) showMedia(variant.featured_media.id);
      try {
        history.replaceState(null, '', '?variant=' + variant.id);
      } catch (e) { /* ignore */ }
    }

    groups.forEach(function (group) { group.addEventListener('change', update); });
  }

  qsa('[data-product-section]').forEach(initProduct);

  /* ---------- Collection filters: apply when changed ---------- */
  qsa('[data-filter-form]').forEach(function (form) {
    qsa('input[type="checkbox"], input[type="number"], select', form).forEach(function (el) {
      el.addEventListener('change', function () { form.submit(); });
    });
  });

  /* ---------- Cart: update when quantity changes ---------- */
  qsa('[data-cart-form]').forEach(function (form) {
    qsa('[data-cart-qty]', form).forEach(function (input) {
      input.addEventListener('change', function () {
        var flag = doc.createElement('input');
        flag.type = 'hidden';
        flag.name = 'update';
        flag.value = 'Update';
        form.appendChild(flag);
        form.submit();
      });
    });
  });
})();
